export { default } from './Icon';
export { iconsMap } from './icons';
import { IconProps as _IconProps } from './Icon';
export { iconNames } from './types';
import { IconName as _IconName } from './types';
export type IconProps = _IconProps;
export type IconName = _IconName;
